module.exports = __webpack_public_path__ + "img/monitoring.86351fd8.svg";